<template>
  <section v-home-reveal class="looks" :aria-label="t('homeLooksTitle')">
    <div class="looks-copy">
      <h2>{{ t('homeLooksTitle') }}</h2>
    </div>
    <div class="looks-bento home-stagger">
      <figure
        v-for="(look, index) in tiles"
        :key="look.titleKey"
        :class="['tile', { featured: index === 0 }]"
      >
        <img :src="look.src" :alt="t(look.titleKey)" />
        <figcaption>
          <span>{{ t(look.titleKey) }}</span>
        </figcaption>
      </figure>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_LOOKS } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();
    const tiles = [HOME_LOOKS[0], HOME_LOOKS[1], HOME_LOOKS[4]];

    return {
      t,
      tiles,
    };
  },
});
</script>
<style scoped lang="scss">
.looks {
  margin: 0 0 56px;
  text-align: left;
}

.looks-copy {
  max-width: 46ch;
  margin: 0 0 22px;
}

h2 {
  margin: 0 0 10px;
  font-size: clamp(1.7rem, 3.4vw, 2.6rem);
  font-weight: 600;
  letter-spacing: -0.045em;
}

.looks-bento {
  display: grid;
  grid-template-columns: 1.45fr 0.9fr;
  grid-template-rows: 1fr 1fr;
  gap: 14px;
  min-height: min(58vh, 560px);
}

.tile {
  position: relative;
  margin: 0;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(246, 243, 238, 0.14);
  background: rgba(20, 16, 24, 0.4);
}

.tile.featured {
  grid-row: 1 / 3;
}

.tile img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s ease;
}

.tile:hover img {
  transform: scale(1.06);
}

figcaption {
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 14px;
  color: #f6f3ee;
}

figcaption span {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  background: rgba(20, 16, 24, 0.62);
  backdrop-filter: blur(10px);
}

@media (max-width: 800px) {
  .looks-bento {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    min-height: 0;
  }

  .tile.featured {
    grid-column: 1 / -1;
    aspect-ratio: 4 / 5;
    min-height: 280px;
  }

  .tile:not(.featured) {
    aspect-ratio: 4 / 5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .tile img {
    transition: none;
  }
}
</style>
